const translations = {
    addCertification: 'Add certification',
    emptyDescription: 'Add a certification to keep this applicator’s records up to date.',
    emptyHeading: 'No certifications yet',
    listLabel: 'Applicator certifications',
    loadError: 'Certifications could not be loaded.',
    loadMore: 'Load more',
    title: 'Pesticide Certifications',
    unavailableDescription: 'This applicator’s certifications could not be read. Try again shortly.',
    unavailableHeading: 'Certifications unavailable'
};

export default translations;
